import React from 'react';
import { UserShowcasePageType } from '../../../lib/api/custom-page.types';
import { EmbedContainer } from '../../../lib/kv-embed';

export const ShowcaseCustomPage: React.FunctionComponent<UserShowcasePageType> = (props: UserShowcasePageType): JSX.Element | null => {
  if (props) return <EmbedContainer.Showcase embedId={props.embedCodeId} />;
  return null;
};
